<div class="address-dialog">
    <div class="container" style="background-color: #c8c8d2; height: 35px">
        <h1 style="color: black; font-weight: 400">Select Delivery Address</h1>
    </div>
    <form [formGroup]="addressForm" (ngSubmit)="onSubmit()">
        <div class="md-dialog-content user-role-dialog-content" style="padding: 20px">
            <div>
                <label for="">Account<span class="text-danger"> *</span></label>
                <select class="form-select" formControlName="account" disabled style="width: 95%; height: 40px">
                    <option>{{ data.account }}</option>
                </select>
            </div>

            <div class="mt-3">
                <label for="">Delivery Address <span class="text-danger"> *</span></label>
                <ng-select [items]="data.deliveryAddressList" required bindLabel="deliveryAddressText" [(ngModel)]="selectedAddress"
                    class="form-control1 address-dropdown" formControlName="deliveryAddressList" appendTo="body"
                    placeholder="-Select Address-" style="width: 95%">
                </ng-select>
                <span *ngIf="deliveryAddressList && deliveryAddressList.invalid && deliveryAddressList.touched" class="text-danger">Delivery Address is required
                </span>
            </div>
            <button class="proceed prim-button-link" type="submit" (click)="onNoClick()">
                PROCEED
            </button>
        </div>
    </form>
</div>